export default __webpack_public_path__ + "static/media/iusdLogo.573f8230.svg";